import clsx from 'clsx';
import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

import { TippingInfo } from '..';

import styles from './index.module.scss';

interface CardProps {
  info: TippingInfo;
  style?: CSSProperties;
}

function Card({
  info: {
    title, description, Icon, isGrren, url,
  },
  style,
}: CardProps) {
  return (
    <Link
      className={clsx(styles.card, isGrren && styles.cardGreen)}
      style={style}
      to={url || '#'}
    >
      <div className={styles.iconPosition}>
        <Icon className={styles.icon} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </Link>
  );
}

export default Card;
